var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSoundModuleLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 12V14H12.666V12H11.3327V10.6667H15.3327V12H13.9993ZM3.33268 12V14H1.99935V12H0.666016V10.6667H4.66602V12H3.33268ZM7.33268 4V2H8.66602V4H9.99935V5.33333H5.99935V4H7.33268ZM7.33268 6.66667H8.66602V14H7.33268V6.66667ZM1.99935 9.33333V2H3.33268V9.33333H1.99935ZM12.666 9.33333V2H13.9993V9.33333H12.666Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoundModuleLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sound-module-line.1e1a6976.svg";
export { ForwardRef as ReactComponent };